import api from './'

export default {

	/**
	 * Get bookings
	 * @param params
	 */
	get(params = {}) {
		return api
			.get("/bookings", {
				params: params,
			})
			.then((response) => {
				return response.data;
			});
	},

	/**
	 * Show booking
	 * @param bookingId
	 * @param params
	 */
	show(bookingId, params) {
		return api
			.get(`/bookings/${bookingId}`, {
				params: params,
			})
			.then((response) => {
				return response.data;
			});
	},

	/**
	 * Confirm booking
	 * @param bookingId
	 * @param data
	 */
	confirm(bookingId, data) {
		return api
			.post(`/bookings/${bookingId}/confirm`, data)
			.then((response) => {
				return response.data;
			});
	},

	/**
	 * Decline booking
	 * @param bookingId
	 * @param data
	 */
	decline(bookingId, data) {
		return api
			.post(`/bookings/${bookingId}/decline`, data)
			.then((response) => {
				return response.data;
			});
	},

	/**
	 * Cancel booking
	 * @param bookingId
	 * @param data
	 */
	cancel(bookingId, data) {
		return api
			.post(`/bookings/${bookingId}/cancel`, data)
			.then((response) => {
				return response.data;
			});
	},

	/**
	 * Create payment transaction for booking request
	 * @param bookingRequestId
	 * @param data
	 */
	createPaymentTransaction(bookingRequestId, data) {
	  return api
			.post(`/bookingRequests/${bookingRequestId}/paymentTransactions`, data)
			.then(response => {
				return response.data
			});
	},

	/**
	 * Get booking requests
	 * @param params
	 */
	getBookingRequests(params) {
		return api
			.get(`/bookingRequests`, {
				params: params,
			})
			.then((response) => {
				return response.data;
			});
	},

	/**
	 * Create booking request
	 * @param data
	 */
	createBookingRequest(data) {
		return api.post(`/bookingRequests`, data).then((response) => {
			return response.data;
		});
	},

	/**
	 * Show booking request
	 * @param bookingRequestId
	 * @param params
	 */
	showBookingRequest(bookingRequestId, params) {
		return api
			.get(`/bookingRequests/${bookingRequestId}`, {
				params: params,
			})
			.then((response) => {
				return response.data;
			});
	},

	/**
	 * Bank Verification for booking request
	 * @param bookingRequestId
	 * @param params
	 */
	bankVerificationBookingRequest(bookingRequestId, params) {
		return api
			.get(`/bookingRequests/${bookingRequestId}/bankVerification`, {
				params: params,
			})
			.then((response) => {
				return response.data;
			});
	},

	/**
	 * Restart a booking request
	 * @param bookingRequestId
	 * @param data
	 */
	restart(bookingRequestId, data) {
		return api
			.post(`/bookingRequests/${bookingRequestId}/restart`, data)
			.then(response => {
				return response.data
			});
	},

	/**
	 * Refund booking request
	 * @param bookingRequestId
	 * @param data
	 */
	refundBookingRequest(bookingRequestId, data) {
		return api
			.post(`/bookingRequests/${bookingRequestId}/refund`, data)
			.then(response => {
				return response.data
			});
	},

}
